import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogClose } from '@angular/material/dialog';
import { Component, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RestClientService } from '@core/service/rest-client.service';
import { AuthService } from '@core/service/auth.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { DateTimeFormatPipe } from '@shared/pipe/date-time-format.pipe';
import _ from 'lodash';

export interface PrescriptionActeChatDialogData {
  item: any; // prescription_acte
}

@Component({
  selector: 'app-prescription-acte-chat-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogContent,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    DateTimeFormatPipe,
  ],
  templateUrl: './prescription-acte-chat-dialog.component.html',
  styleUrl: './prescription-acte-chat-dialog.component.scss',
})
export class PrescriptionActeChatDialogComponent implements OnDestroy {
  itemToSave: any = {};
  messages: any[] = [];
  imageName = '';
  currentItemImage: any = {};
  dialogTitle = '';
  user: any;

  private intervalId: any;

  constructor(
    public dialogRef: MatDialogRef<PrescriptionActeChatDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrescriptionActeChatDialogData,
    private restClient: RestClientService,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    this.dialogTitle = 'Discussion – ' + (data.item?.codification || data.item?.acte_libelle || '');
    this.getMessages();
    this.intervalId = setInterval(() => this.getMessages(), 5000);
  }

  getMessages(): void {
    const request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: { prescription_acte_id: this.data.item.id },
    };
    this.restClient.post('prescriptionActeChat/getByCriteria', request).subscribe(
      (res: any) => {
        this.messages = res?.items ? _.orderBy(res.items, ['created_at'], ['asc']) : [];
        this.messages.forEach((msg: any) => {
          msg.image_full_url = msg.image || msg.ged_file_url || null;
        });
      },
      () => { this.messages = []; },
    );
  }

  uploadFile(event: any): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const parts = file.name.split('.');
      const extension = parts[parts.length - 1];
      const fileName = parts.slice(0, -1).join('.');
      this.imageName = file.name;
      reader.onload = (e: any) => {
        const base64 = e.target.result.split(',')[1];
        this.currentItemImage = { fileBase64: base64, fileName, extension, typeDocument: 'prescription_acte_chat' };
      };
      reader.readAsDataURL(file);
    }
  }

  saveItem(): void {
    if (!this.itemToSave.message && !this.currentItemImage.fileBase64) { return; }
    const payload: any = {
      prescription_acte_id: this.data.item.id,
      text: this.itemToSave.message,
    };
    if (this.currentItemImage?.fileBase64) {
      payload.file_data = this.currentItemImage;
    }
    const request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [payload],
    };
    this.restClient.post('prescriptionActeChat/create', request).subscribe(
      (res: any) => {
        if (res && !res.hasError) {
          this.itemToSave = {};
          this.imageName = '';
          this.currentItemImage = {};
          this.getMessages();
        } else {
          this.utilities.showNotification('snackbar-danger',
            res?.status?.message || 'Erreur', 'bottom', 'center');
        }
      },
      () => {},
    );
  }

  isMine(msg: any): boolean {
    return msg.created_by_id === this.user.id;
  }

  clearInterv(): void { clearInterval(this.intervalId); }
  ngOnDestroy(): void { clearInterval(this.intervalId); }
}
